<div class="modal">
  <i class="fal fa-times modal__close" (click)="close()"></i>

  <!-- <h2 class="h2">{{data?.date | date:'longDate'}}</h2> -->
  <div class="mt-0100">
    <app-event-list [showRsvps]="!entityId" [events]="day.events" [showDateHeader]="true" [entityId]="entityId"
      (eventResponseUpdated)="onListEventResponseUpdate($event)"></app-event-list>
  </div>
</div>
